import Vue from 'vue'
import Router from 'vue-router'
import Intro from './views/Intro.vue';
import Tutorial from './views/Tutorial.vue';
import Game from './views/Game.vue';
import Outro from './views/Outro.vue';
import EventBus from '@/EventBus.js';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Intro
    },
    {
      path: '/intro',
      name: 'intro',
      component: Intro
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: Tutorial
    },
    {
      path: '/game',
      name: 'game',
      component: Game
    },
    {
      path: '/outro',
      name: 'outro',
      component: Outro
    }
  ]
});

router.beforeEach((to, from, next) => {
  EventBus.removeAllListeners();
  next();
});
export default router;
